module.exports = __webpack_public_path__ + "static/media/logo.df6fe5dc.svg";